import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProgressBar from "./portal/components/ProgressBar";
import Login from "./portal/Login";
import Dashboard from "./portal/Dashboard";
// import Document from "./portal/Document";
// import Provisional from "./portal/Provisional";
// import Migration from "./portal/Migration";
// import Bonafide from "./portal/Bonafide";
// import Character from "./portal/Character";
// import Duplicate from "./portal/Duplicate";
// import Internship from "./portal/Internship";
// import Consolidated from "./portal/Consolidated";
// import Course from "./portal/Course";
// import CGPA from "./portal/CGPA";
import Pharmacy from "./portal/Pharmacy";

const App = () => {
  return (
    <BrowserRouter>
      <ProgressBar /> 
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        {/* <Route path="/document" element={<Document />} />
        <Route path="/provisional-certificate" element={<Provisional />} />
        <Route path="/migration-certificate" element={<Migration />} />
        <Route path="/bonafide-certificate" element={<Bonafide />} />
        <Route path="/character-certificate" element={<Character />} />
        <Route path="/duplicate-certificate" element={<Duplicate />} />
        <Route path="/internship-permission" element={<Internship />} />
        <Route path="/transcript-certificate" element={<Consolidated />} />
        <Route path="/course-completion" element={<Course />} />
        <Route path="/cgpa-percentage" element={<CGPA />} /> */}
        <Route path="/pharmacyData" element={<Pharmacy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;